import {IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact} from '@ionic/react';
import {IonReactRouter} from '@ionic/react-router';
import {Redirect, Route} from 'react-router-dom';
import {useMediaQuery} from 'react-responsive';
import {authService} from './api/authService';
import {useEffect, useState} from 'react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Pages */
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import HomePage from './pages/HomePage';
import HealthDeclarationPage from './pages/HealthDeclarationPage';
import ColorDeclarationRouting from './pages/ColorDeclarationRouting';
import SettingsPage from './pages/SettingsPage';
import NewsPage from './pages/NewsPage';
import OwnDeclarationRouting from './pages/OwnDeclarationRouting';

/* Components */
import AppLayoutMenu from './components/AppLayout/AppLayoutMenu';

setupIonicReact();


const App: React.FC = () => {
  const isPhone = useMediaQuery({
    query: '(max-width: 640px)',
  });
  const [tokenState, setTokenState] = useState(authService.tokenValue);

  useEffect(() => {
    authService.setAccessTokenFromLocalStorage();
    authService.setRefreshTokenFromLocalStorage();
    authService.currentToken.subscribe(setTokenState);
    if (tokenState == '') {
      authService.logout();
    }
  }, []);

  const isLoggedIn = () => {
    return tokenState !== '';
  };

  return (
    <IonApp>
      <IonReactRouter>
        {isLoggedIn() ? (
            <IonSplitPane contentId="main">
              <AppLayoutMenu style='md:w-1/5' side={isPhone ? 'end' : 'start'}/>
              <IonRouterOutlet id="main">
                <Route exact path="/">
                  <Redirect to='/home'/>
                </Route>
                <Route path="/home" exact={true}>
                  <HomePage/>
                </Route>
                <Route path="/halsodeklaration" exact={true}>
                  <HealthDeclarationPage />
                </Route>
                <Route path="/installningar" exact={true}>
                  <SettingsPage />
                </Route>
                <Route path="/home/:id" exact={true}>
                  <NewsPage />
                </Route>
                <Route path="/fargdeklaration" component={ColorDeclarationRouting}/>
                <Route path="/egen-deklaration" component={OwnDeclarationRouting}/>
              </IonRouterOutlet>
            </IonSplitPane>
          ) : (
            <IonRouterOutlet>
              <Route path='*'>
                <LoginPage/>
              </Route>
              <Route path="/" exact={true}>
                <LoginPage/>
              </Route>
              <Route path="/register" exact={true}>
                <RegisterPage/>
              </Route>
              <Route path="/forgot-password" exact={true}>
                <ForgotPasswordPage/>
              </Route>
            </IonRouterOutlet>
          )}
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
